import React from 'react';
import './TextContent.css';

function TextContent() {
    return (
        <div className="text-content">
        </div>
    );
}

export default TextContent;
